import { Injectable, Injector } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import { URLSearchParams, ResponseContentType } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/catch';
import { IdentityAuthService } from '@services/identity-auth/identity-auth.service';
import { ApiService } from '@services/api/api.service';
import { AppSettings } from '../../entities/AppSettings';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { AppSettingsService } from '@services/app-settings/app-settings.service';
import { appSettings } from '../../modules/shared/components/appSettings';
import { FileSaverService } from 'ngx-filesaver';
import { type } from 'os';
@Injectable({
  providedIn: 'root'
})
export class FileDownloadService {
  constructor(public auth: IdentityAuthService,
    private apiService: ApiService,
    protected appSettingsService: AppSettingsService,
    protected httpClient: HttpClient,
  private _FileSaverService: FileSaverService) {

  }
  
  private getFile(url: string) {
    let headers = new HttpHeaders().append("Authorization", "Bearer " +
      this.auth.access_token)
    return this.httpClient.get(appSettings.apiServiceAddress +  url, { responseType: 'arraybuffer', headers: headers });
  }

  public downloadFile(endPoint: string,  fileName?:string) {
    this.getFile(endPoint).subscribe(respData => {
      var blob = new Blob([respData]);
      if (fileName)
        this._FileSaverService.save(blob, fileName);
        //saveAs(blob,fileName);
      else this._FileSaverService.save(blob);
        //saveAs(blob);
      //var url = window.URL.createObjectURL(blob);
      //var links = document.createElement('a');
      //links.download = "";
      //links.target = "_blank";
      //links.href = url;
      //links.click();
      //window.URL.revokeObjectURL(url);
      //document.body.removeChild(links);

    }, error => {

    });
  }
}
